module.exports = __webpack_public_path__ + "static/media/bg-thankyou-sm.be9c1bc0.png";